import { Column } from '@/components'
import { Skeleton } from '@surein/ui'

export const SkeletonLoader = () => {
  return (
    <Column gap="32px">
      <Column gap="16px">
        <Skeleton count={1} height="32px" width="80%" />
        <Column gap="8px">
          <Skeleton count={12} height="24px" />
        </Column>
      </Column>
      <Column gap="8px">
        <Skeleton count={1} height="32px" width="80%" />
        <Column gap="8px">
          <Skeleton count={12} height="24px" />
        </Column>
      </Column>
      <Column gap="8px">
        <Skeleton count={1} height="32px" width="80%" />
        <Column gap="8px">
          <Skeleton count={12} height="24px" />
        </Column>
      </Column>
    </Column>
  )
}
